import '../../assets/stylesheets/application.scss'
import 'iframe/messages'
import 'components'
import 'elm'
import 'relation-map'
import 'csrf-xhr'
import Rails from '@rails/ujs'

require.context('../../assets/images', true)
Rails.start()
